import { getIsServerEnv } from '@/shared/modules/environment';

import { normalizeUrlBaseValue, normalizeUrlPathname } from './common';

const getBaseUrlToRouteHandlerApi = () => {
  const baseUrl = getIsServerEnv() === true ? process.env.NODE_HOST_URL : window.location.origin;
  return normalizeUrlBaseValue(baseUrl);
};

/**
 * @param pathname {string} should starts from '/'
 *
 * By default, all Next.js "Route Handlers" are available by route in the `app/api` folder, but in our case this
 * folder is named `app/${process.env.NEXT_PUBLIC_PATHNAME_PREFIX_TO_ROUTE_HANDLERS}` because the `/api' route is
 * used by our real `.Net API `.
 *
 * https://nextjs.org/docs/app/building-your-application/routing/route-handlers
 *
 * @example const url = getUrlToRouteHandlerApi('/profile-mock');
 */
export const getUrlToRouteHandlerApi = (pathname: string) => {
  const pathnamePrefix = process.env.NEXT_PUBLIC_PATHNAME_PREFIX_TO_ROUTE_HANDLERS;
  return new URL(`${pathnamePrefix}${normalizeUrlPathname(pathname)}`, getBaseUrlToRouteHandlerApi());
};
